import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { setupNavigation } from "../../redux/actions/navItemsActions";
import PropTypes from "prop-types";
import { getDashboardData } from "../../api/adminApi";
import Spinner from "../common/Spinner";

function DashboardPage(
    {
        setupNavigation,
        user
    }
) {

    const [dashboardData, setDashboardData] = useState(null);
    const [processing, setProcessing] = useState(true);

    const navigationItems =
    {
        sections: [{
            name: 'Admin',
            items: [
                {
                    path: '/_adm/dashboard',
                    text: 'Dashboard',
                    icon: 'fas fa-tachometer-alt'
                },
                {
                    path: '/_adm/users',
                    text: 'Users',
                    icon: 'fas fa-user'
                },
                {
                    path: '/_adm/groups',
                    text: 'Groups',
                    icon: 'fas fa-users'
                },
                {
                    path: '/_adm/routes',
                    text: 'Routes',
                    icon: 'fas fa-route'
                },
                {
                    path: '/_adm/errors',
                    text: 'Errors',
                    icon: 'fas fa-bug'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "Administration | JustGoRide";
        setupNavigation(navigationItems);
        getDashboardData()
            .then(data => {
                setDashboardData(data)
                setProcessing(false);
            })
            .catch(error => {
                console.error(error);
                setProcessing(false);
            })
    }, []);

    return (
        <React.Fragment>
            <div className="mt-2">
                <h3 className="ml-3 mb-3">Administration Dashboard</h3>
            </div>
            {processing ?
                <Spinner />
                :
                <div className="row justify-content-center">
                    <div className="card col-5 mx-3">
                        <div className="card-body">
                            <h5 class="card-title">User Activity</h5>
                            <ul>
                                <li>Total users: <span class="highlight">{dashboardData.userStatistics.totalUsers}</span></li>
                                <li>User registrations in last 30 days: <span class="highlight">{dashboardData.userStatistics.totalRegistrationsInLast30Days}</span></li>
                                <li>Users active in last 30 days: <span class="highlight">{dashboardData.userStatistics.totalActiveInLast30Days}</span></li>
                                <li>Total Number of Donations: <span class="highlight">{dashboardData.userStatistics.totalDonations}</span></li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="card col-5 mx-3">
                        <div className="card-body">
                            <h5 class="card-title">Route Activity</h5>
                            <ul>
                                <li>Uploads in last 30 days:<span class="highlight">{dashboardData.routeStatistics.totalUploads}</span>
                                    <ul>
                                        <li>File: <span class="highlight">{dashboardData.routeStatistics.totalFileUploads}</span></li>
                                        <li>Garmin: <span class="highlight">{dashboardData.routeStatistics.totalGarminUploads}</span></li>
                                        <li>Creator: <span class="highlight">{dashboardData.routeStatistics.totalCreatorUploads}</span></li>
                                        <li>Public Uploads: <span class="highlight">{dashboardData.routeStatistics.totalPublicUploads}</span></li>
                                        <li>Private Uploads: <span class="highlight">{dashboardData.routeStatistics.totalPrivateUploads}</span></li>
                                    </ul>
                                </li>
                                <li>Downloads in the last 30 days: <span class="highlight">{dashboardData.routeStatistics.totalDownloads}</span>
                                    <ul>
                                        <li>File: <span class="highlight">{dashboardData.routeStatistics.totalFileDownloads}</span></li>
                                        <li>Garmin: <span class="highlight">{dashboardData.routeStatistics.totalGarminDownloads}</span></li>
                                    </ul>
                                </li>
                            </ul>
                            <h5>Top 20 Downloads</h5>
                            <ol>
                                {
                                    dashboardData.routeStatistics.top20Downloads.map((route) => {
                                        return (
                                            <li key={route.routeId}><Link to={`/routes/${route.routeId}`}>{route.routeName}</Link><span class="highlight">{route.timesDownloaded}</span></li>
                                        );
                                    })
                                }
                            </ol>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>

    );
}

DashboardPage.propTypes = {
    setupNavigation: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/administration/DashboardPage.js